module.exports = __webpack_public_path__ + "docs/img/cloud-js.0fc092df.png";